<section id="content" *ngIf="lang">

  <div class="page page-profile">

    <div class="pageheader">

      <h2>Configuration and email

      </h2>

    </div>

    <!-- page content -->
    <div class="pagecontent">


      <!-- row -->
      <div class="row">

        <div class="col-md-12">

          <!-- tile -->
          <section class="tile tile-simple">

            <!-- tile body -->
            <div class="tile-body p-0">

              <div role="tabpanel">


                <!-- Tab panes -->
                <div class="tab-content">

                  <div role="tabpanel" class="tab-pane active" id="generalTab">

                    <div class="wrap-reset">

                      <ng-template #ErrorMsg let-msg="msg" let-value="value" let-submitted="submitted">
                        <div *ngFor="let validation of msg">
                          <div class="error-message"
                            *ngIf="value.hasError(validation.type) && (value.touched || value.dirty || submitted)">
                            {{validation.message}}
                          </div>
                        </div>
                      </ng-template>

                      <form [formGroup]="createForm" (ngSubmit)="onSubmit()" class="form-validation">

                        <div class="row">
                          <table class="table table-striped table-hover">
                            <thead>
                              <tr><th>S.NO</th>
                              <th>Module Name</th>
                              <th>Email</th>
                            </tr></thead>
                            <tbody>
                              <tr>
                                <td>1</td>
                                <td>Deadline</td>
                                <td>
                                  <input type="text" class="form-control" name="deadline" value="deadline@kaizencloud.eu" required="">
                                </td>
                              </tr>
              
                              <tr>
                                <td>2</td>
                                <td>Servicing</td>
                                <td>
                                  <input type="text" class="form-control" name="servicing" value="servicing@kaizencloud.eu " required="">
                                </td>
                              </tr>
              
                              <tr>
                                <td>3</td>
                                <td>HR Courses</td>
                                <td>
                                  <input type="text" class="form-control" name="hr_courses" value="hrcourses@kaizencloud.eu" required="">
                                </td>
                              </tr>
              
                              <tr>
                                <td>4</td>
                                <td>HR Notification</td>
                                <td>
                                  <input type="text" class="form-control" name="hr_notification" value="hrnotification@kaizencloud.eu" required="">
                                </td>
                              </tr>
              
                            <tr>
                                <td>5</td>
                                <td>HR Visit</td>
                                <td>
                                 <input type="text" class="form-control" name="hr_visit" value="hrvisit@kaizencloud.eu" required="">                  </td>
                              </tr>
              
              
                              <tr>
                                <td>6</td>
                                <td>Measurement Tools</td>
                                <td>
                                  <input type="text" class="form-control" name="measurement_tools" value="measurementtools@kaizencloud.eu " required="">
                                </td>
                              </tr>
              
                              <tr>
                                <td>7</td>
                                <td>Problem Solving</td>
                                <td>
                                  <input type="text" class="form-control" name="problem_solving" value="problemsolving@kaizencloud.eu " required="">
                                </td>
                              </tr>
              
                              <tr>
                                <td>8</td>
                                <td>Document Management</td>
                                <td>
                                  <input type="text" class="form-control" name="document_management" value="document@kaizencloud.eu" required="">
                                </td>
                              </tr>
              
                              <tr>
                                <td>9</td>
                                <td>Customers</td>
                                <td>
                                  <input type="text" class="form-control" name="customers" value="customers@kaizencloud.eu " required="">
                                </td>
                              </tr>
              
                              <tr>
                                <td>10</td>
                                <td>Consultancy</td>
                                <td>
                                  <input type="text" class="form-control" name="consultancy" value="consultancy@kaizencloud.eu " required="">
                                </td>
                              </tr>
              
                              <tr>
                                <td>11</td>
                                <td>Academy</td>
                                <td>
                                  <input type="text" class="form-control" name="academy" value="academy@kaizencloud.eu " required="">
                                </td>
                              </tr>
                              
                              <tr>
                                <td>12</td>
                                <td>Project</td>
                                <td>
                                  <input type="text" class="form-control" name="project" value="project@kaizencloud.eu " required="">
                                </td>
                              </tr>
                              <tr>
                                <td colspan="2"></td>
                                <td><input type="submit" class="btn btn-primary trig" name="mail_wizard" value="Save"></td>	
                              </tr>
                            </tbody>
                          </table>


                        </div>


                      </form>

                    </div>

                  </div>



                </div>

              </div>

            </div>
            <!-- /tile body -->

          </section>
          <!-- /tile -->

        </div>


      </div>
      <!-- /page content -->

    </div>
  </div>

</section>